// extracted by mini-css-extract-plugin
export var header = "_uu-1";
export var maskBottom = "_uu-6";
export var maskMiddle = "_uu-7";
export var maskTop = "_uu-5";
export var root = "_uu-0";
export var scrollDownButton = "_uu-3";
export var scrollDownButtonHidden = "_uu-4";
export var viewport = "_uu-2";